import React, { Component } from "react";
import { Layout, Menu, Divider } from "antd";
import Users from "../../components/adminSide/users";
import Courses from "../../components/adminSide/courses";
import Welcome from "../../components/adminSide/welcomeScreen";
import Progress from "../../components/adminSide/progress";
import "./style.css";
import {
  UserAddOutlined,
  FileAddOutlined,
  HomeOutlined,
  SmileOutlined,
} from "@ant-design/icons";
const { Sider, Content } = Layout;

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: "1",
      collapsed: true,
    };
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  render() {
    return (
      <div className="mDiv">
        <div>
          <div>
            <Layout className="layOutCls">
              <Sider
                className="customSider"
                trigger={null}
                collapsible
                collapsed={this.state.collapsed}
                onPointerEnter={() => {
                  this.toggle();
                }}
                onPointerLeave={() => {
                  this.toggle();
                }}
              >
                <div className="logo" />
                <Menu theme="dark" mode="inline" defaultSelectedKeys={["1"]}>
                  <Menu.Item
                    key="1"
                    onClick={() => {
                      this.setState({
                        key: "1",
                      });
                    }}
                    icon={<HomeOutlined />}
                  >
                    Welcome
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    onClick={() => {
                      this.setState({
                        key: "2",
                      });
                    }}
                    icon={<UserAddOutlined />}
                  >
                    Users
                  </Menu.Item>
                  <Menu.Item
                    key="3"
                    onClick={() => {
                      this.setState({
                        key: "3",
                      });
                    }}
                    icon={<FileAddOutlined />}
                  >
                    Courses
                  </Menu.Item>
                  <Menu.Item
                    key="4"
                    onClick={() => {
                      this.setState({
                        key: "4",
                      });
                    }}
                    icon={<SmileOutlined />}
                  >
                    Progress
                  </Menu.Item>
                </Menu>
              </Sider>

              <Layout className="site-layout">
                {this.state.key === "1" ? (
                  <Content
                    className="site-layout-background"
                    style={{
                      padding: 12,
                      minHeight: 280,
                      textAlign: "center",
                      fontSize: "40px",
                    }}
                  >
                    <div className="marginTop">
                      <Divider>Welcome</Divider>
                      <Welcome />
                    </div>
                  </Content>
                ) : this.state.key === "2" ? (
                  <Content
                    className="site-layout-background"
                    style={{
                      padding: 12,
                      minHeight: 280,
                      textAlign: "center",
                      fontSize: "40px",
                    }}
                  >
                    <div className="marginTop">
                      <Divider>Users</Divider>
                      <Users />
                    </div>
                  </Content>
                ) : this.state.key === "3" ? (
                  <Content
                    className="site-layout-background"
                    style={{
                      padding: 12,
                      minHeight: 280,
                      textAlign: "center",
                      fontSize: "40px",
                    }}
                  >
                    <div className="marginTop">
                      <Divider>Courses</Divider>
                      <Courses />
                    </div>
                  </Content>
                ) : this.state.key === "4" ? (
                  <Content
                    className="site-layout-background"
                    style={{
                      padding: 12,
                      minHeight: 280,
                      textAlign: "center",
                      fontSize: "40px",
                    }}
                  >
                    <div className="marginTop">
                      <Divider>Progress</Divider>
                      <Progress />
                    </div>
                  </Content>
                ) : null}
              </Layout>
            </Layout>
          </div>
        </div>
      </div>
    );
  }
}

export default Admin;
